module.exports = __webpack_public_path__ + "static/media/LogicWheel6_2_drag_3.912ebb56.png";